import * as React from 'react'
import { AutoCompleteInput, Button, Checkbox, ColorPicker, IconButton, Input, Label, Select } from 'uxp/components'
import ActionEditorLink, { extractAction, IAction } from '../action-editor/ActionEditor'
import { applyAtPath, IBaseProperty, IUIPropertyDefinition } from '../common'
import { BackgroundPositionEditor, CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from './common'
import { IBackgroundProps, ITextProps } from './properties'
import jp from 'jsonpath'
import { hasProperty, hasValue } from '../../../util'
import { tr } from 'date-fns/locale'
import { $L } from '../../../localize';

export interface IMarginProperty extends IBaseProperty {
    top?: number,
    bottom?: number,
    left?: number,
    right?: number,
    title?: string,
    hideTop?: boolean,
    hideBottom?: boolean,
    hideLeft?: boolean,
    hideRight?: boolean
}

export function extractMargins(props: IMarginProperty) {
    return {
        top: hasValue(props?.top, true) ? props.top : 50,
        bottom: hasValue(props?.bottom, true) ? props.bottom : 50,
        left: hasValue(props?.left, true) ? props.left : 50,
        right: hasValue(props?.right, true) ? props.right : 50,
    }
}

export function MarginProperty(defaultProps: IMarginProperty,): IUIPropertyDefinition<IMarginProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps || { top: 50, bottom: 50, left: 50, right: 50 }
            containerId = hasValue(containerId) ? containerId + '-' : ''           
            return <PropertyContainer>
                <PropertyContainerTitle>{_props?.title || $L('widgetdesigner.props.chart-margins', 'Chart Margins')}</PropertyContainerTitle>
                <PropertyGroup>

                    {!_props?.hideTop &&
                        <Property id={containerId + 'top'} >
                            <PropertyTitle>{$L('widgetdesigner.props.top', 'Top')}</PropertyTitle>
                            <Input
                                type='number'
                                value={(_props.top || 0).toString()}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    if (num < 0) num = 0
                                    else if (num > 200) num = 200

                                    let newProps = applyAtPath(_props, '$.top', () => (num))
                                    props.onChange(newProps)
                                }}

                                inputAttr={{
                                    max: '200',
                                    min: '0'
                                }}
                            />
                        </Property>
                    }

                    {!_props?.hideBottom &&
                        <Property id={containerId + 'bottom'} >
                            <PropertyTitle>{$L('widgetdesigner.props.bottom', 'Bottom')}</PropertyTitle>
                            <Input
                                type='number'
                                value={(_props.bottom || 0).toString()}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    if (num < 0) num = 0
                                    else if (num > 200) num = 200

                                    let newProps = applyAtPath(_props, '$.bottom', () => (num))
                                    props.onChange(newProps)
                                }}

                                inputAttr={{
                                    max: '200',
                                    min: '0'
                                }}
                            />
                        </Property>
                    }

                    {!_props?.hideLeft &&
                        <Property id={containerId + 'left'} >
                            <PropertyTitle>{$L('widgetdesigner.props.left', 'Left')}</PropertyTitle>
                            <Input
                                type='number'
                                value={(_props.left || 0).toString()}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    if (num < 0) num = 0
                                    else if (num > 200) num = 200

                                    let newProps = applyAtPath(_props, '$.left', () => (num))
                                    props.onChange(newProps)
                                }}

                                inputAttr={{
                                    max: '200',
                                    min: '0'
                                }}
                            />
                        </Property>
                    }

                    {!_props?.hideRight &&
                        <Property id={containerId + 'right'} >
                            <PropertyTitle>{$L('widgetdesigner.props.right', 'Right')}</PropertyTitle>
                            <Input
                                type='number'
                                value={(_props.right || 0).toString()}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    if (num < 0) num = 0
                                    else if (num > 200) num = 200

                                    let newProps = applyAtPath(_props, '$.right', () => (num))
                                    props.onChange(newProps)
                                }}

                                inputAttr={{
                                    max: '200',
                                    min: '0'
                                }}
                            />
                        </Property>
                    }


                </PropertyGroup>
            </PropertyContainer>
        }
    }

}